export function deleteCookie(name: string) {
  const isServerSide = typeof document === "undefined";
  if (!isServerSide) {
    document.cookie =
      name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }
}

export function setCookie({
  name,
  value,
  days,
}: {
  name: string;
  value: string;
  days: number;
}) {
  const isServerSide = typeof document === "undefined";
  if (!isServerSide && value.trim() !== "") {
    var expires = "";
    if (days && value) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
}
export function getCookie(name: string, rawCookie = document.cookie) {
  var nameEQ = name + "=";
  var ca = rawCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
